import { useEffect } from 'react';

import { groupMember } from '@/helpers/user';
import { useABTestingV2 } from '@/modules/abTesting';
import { AB_TESTS } from '@/modules/abTesting/constants';
import { useGetCommonStore } from '@/store';

const SPECIAL_USER_GROUP = '1DEP_ab_test1';

export const useAssignSeparatedWageringABTest = () => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();

  const { assignABTestVersion } = useABTestingV2({
    experiment: AB_TESTS.SEPARATED_WAGERING,
  });

  useEffect(() => {
    if (!(groupMember(SPECIAL_USER_GROUP)(user) && user?.canIssueBonuses)) {
      return;
    }

    assignABTestVersion();
  }, [user, assignABTestVersion]);
};
